import 'core-js/stable';
import 'regenerator-runtime/runtime';
import svg4everybody from 'svg4everybody';
import $ from 'jquery';

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { CustomEase } from "gsap/CustomEase";
import SplitType from 'split-type'
import Lenis from '@studio-freight/lenis'

import slick from "slick-carousel/slick/slick";
import Inputmask from "../.../../../node_modules/inputmask/dist/jquery.inputmask.min";

 $(".inputmask").inputmask({"mask": "+7 (999) 999-9999"});

if(document.querySelector(".cursor")) {
	const body = document.querySelector('.portfolio__container ')
	const cursor = document.getElementById('cursor')
	const links = document.querySelectorAll('.work')
	
	let mouseX = 0, mouseY = 0, posX = 0, posY = 0
	
	function mouseCoords(e){
		mouseX = e.pageX
		mouseY = e.pageY
	}

	gsap.to({}, .01, {
		repeat: -1,
		onRepeat: () => {
			posX += (mouseX - posX) / 6
			posY += (mouseY - posY) / 6
			gsap.set(cursor,{
				css: {
					left: posX,
					top: posY
				}
			})
		}
	})
	
	for (let i=0; i < links.length; i++) {
		links[i].addEventListener('mouseover', () => {
			cursor.classList.add('is-active')
			// console.log(links[i].dataset.img)
			let targetImage = links[i].dataset.img
			const t1 = gsap.timeline();
			t1.set(cursor, {
				backgroundImage: `url(${targetImage})`
			})
		})
		links[i].addEventListener('mouseout', () => {
			cursor.classList.remove('is-active')
		})
	}

	
	body.addEventListener('mousemove', e => {
		cursor.classList.remove('hidden')
		mouseCoords(e)
	
	})
	
	body.addEventListener('mouseout', e => {
		cursor.classList.add('hidden')
	})
}





// const text = new SplitType('#target')
// console.log(text.chars)
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(CustomEase); 

gsap.config({
	nullTargetWarn: false,
	trialWarn: false,
});

gsap.set('.null', {opacity: 1})





ScrollTrigger.matchMedia({
	"(min-width: 992px)" : function() {



		const splitTypes = document.querySelectorAll('.reveal-type')

		splitTypes.forEach((char,i) => {

		const bg = char.dataset.bgColor
		const fg = char.dataset.fgColor

		const text = new SplitType(char, { types: 'chars'})

		gsap.fromTo(text.chars, 
			{
			color: bg,
			y: 50,
			opacity: 0
			},
			{
			color: fg,
			duration: 0.3,
			stagger: 0.01,
			y: 0,
			opacity: 1,
			scrollTrigger: {
				trigger: char,
				start: 'top 80%',
				end: 'top 20%',
				scrub: true,
				markers: false,
				toggleActions: 'play play reverse reverse'
			}
		})
		})


		const lenis = new Lenis({});

		//get scroll value
		lenis.on("scroll", (e) => {
			// console.log(e);
		});

		function raf(time) {
			lenis.raf(time);
			requestAnimationFrame(raf);
		}

		requestAnimationFrame(raf);


		const tween = gsap.timeline({
			scrollTrigger: {
				trigger: ".hero",
				// toggleActions: "play reverse restart reset",
				toggleActions: "play none none none",
			},
			repeat: 0,
			repeatDelay: 1
		});

		tween.to(".creative", {
			duration: 6,
			width: '100%',
			delay: .5,
			ease: CustomEase.create("custom", "M0,0,C0.11,0.494,0.192,0.726,0.318,0.852,0.45,0.984,0.504,1,1,1")
		})

		tween.to(".creative__span", {
			duration: 2,
			opacity: 1,
			translateY: 0,
			ease: CustomEase.create("custom", "M0,0,C0,0,0.014,0.136,0.021,0.226,0.04,0.48,0.046,0.612,0.065,0.867,0.072,0.966,0.075,1.017,0.085,1.115,0.091,1.186,0.096,1.224,0.106,1.293,0.109,1.314,0.112,1.327,0.118,1.346,0.121,1.356,0.125,1.364,0.13,1.371,0.131,1.372,0.135,1.373,0.136,1.372,0.139,1.371,0.143,1.366,0.145,1.362,0.152,1.346,0.157,1.334,0.161,1.316,0.185,1.207,0.18,1.143,0.204,1.03,0.211,0.995,0.214,0.975,0.224,0.941,0.229,0.922,0.25,0.91,0.258,0.892,0.261,0.886,0.264,0.882,0.268,0.877,0.271,0.874,0.273,0.87,0.277,0.869,0.281,0.868,0.288,0.868,0.292,0.869,0.298,0.872,0.303,0.876,0.307,0.882,0.336,0.928,0.353,0.965,0.383,1.012,0.389,1.022,0.396,1.028,0.405,1.035,0.412,1.04,0.419,1.043,0.428,1.046,0.433,1.047,0.437,1.046,0.443,1.045,0.448,1.044,0.453,1.043,0.458,1.041,0.486,1.025,0.503,1.012,0.531,0.996,0.539,0.992,0.545,0.99,0.554,0.987,0.562,0.985,0.568,0.984,0.576,0.983,0.587,0.983,0.595,0.983,0.606,0.985,0.636,0.99,0.653,0.996,0.683,1.001,0.698,1.004,0.708,1.005,0.723,1.005,0.779,1.004,0.812,0.999,0.87,0.998,0.92,0.997,1,1,1,1"),
		}, '-=5.8')

		tween.to(".creative", {
			duration: .7,
			rotation: -11.89,
			ease: CustomEase.create("custom", "M0,0,C0.14,0,0.242,0.438,0.272,0.561,0.313,0.728,0.354,0.963,0.362,1,0.37,0.985,0.414,0.873,0.455,0.811,0.51,0.726,0.573,0.753,0.586,0.762,0.662,0.812,0.719,0.981,0.726,0.998,0.788,0.914,0.84,0.936,0.859,0.95,0.878,0.964,0.897,0.985,0.911,0.998,0.922,0.994,0.939,0.984,0.954,0.984,0.969,0.984,1,1,1,1")
		}, '-=5')

		tween.to(".digit", {
			duration: 0.5,
			opacity: 1,
			stagger: 0.2,

		}, '-=4')

		tween.to(".hero .header__container", {
			duration: 0.75,
			opacity: 1,
			translateY: 0,
			
		}, '-=4')


		const tween2 = gsap.timeline({
			scrollTrigger: {
				trigger: ".tplsite__container",
				toggleActions: "play none none none",
				start: 'top 30%',
				// markers: true,
			},
			repeat: 0,
			repeatDelay: 1
		});
		
		tween2.to(".tplsite__image", {
			duration: 0.5,
			opacity: 1,
			stagger: 0.2,
			//ease: "bounce"
		})
/*
		tween.to(".main", {
			duration: 0.5,
			opacity: 1,
			//ease: "bounce"
		})

		tween.to(".header", {
			duration: 0.75,
			opacity: 1,
			translateY: 0,
		}, '-=0.25') // Когда прошла 0.25 секунды анимации .main начинаем анимацию .header


		tween.to(".left-panel", {
			duration: 0.5,
			opacity: 1,
			translateX: 0,
		}, '-=0.5')

		tween.to(".main__title", {
			duration: 1,
			opacity: 1,
			translateY: 0
		}, '-=0.25')

		tween.to(".main__title span", {
			duration: 1,
			color: "#CFA604"
		}, '-=0.45')

		tween.to(".main__btns", {
			duration: 1,
			opacity: 1,
			translateY: 0
		}, '-=1.2')

		tween.to(".main__advantage-item", {
			duration: 1,
			opacity: 1,
			translateY: 0,
			stagger: 0.2,
		}, '-=0.7')


		tween.to(".main__coube", {
			duration: 0.7,
			opacity: 1,
			scale: 1,
			stagger: 0.1,
		}, '-=0.7')


		tween.to(".left-panel__social", {
			duration: 1.5,
			opacity: 1,
			translateY: 0,
			ease: "bounce",
		})


		gsap.to(".service-box",{
			scrollTrigger: {
				trigger: ".services",
				toggleActions: "play reverse restart reset",
				scrub: 1,
				end: "bottom bottom",
			},
			duration: 1.5,
			scale: 1,
			opacity: 1,
			stagger: 0.2
		});

		gsap.to(".reviews .container",{
			scrollTrigger: {
				trigger: ".reviews",
				toggleActions: "play reverse restart reset",
				scrub: 1,
				end: "bottom bottom",
			},
			duration: 1,
			y: 0,
			opacity: 1
		});


		gsap.to(".portfolio .container",{
			scrollTrigger: {
				trigger: ".portfolio",
				toggleActions: "play reverse restart reset",
				scrub: 1,
				end: "bottom bottom",
			},
			duration: 1,
			y: 0,
			opacity: 1
		});




		const company = gsap.timeline({
			scrollTrigger: {
				trigger: ".company",
				toggleActions: "play reverse restart reset",
				scrub: 2,
				start: "top center",
				end: "bottom bottom",
			},
			repeat: 0,
			repeatDelay: 1
		});

		company.to(".company__image", {
			duration: 0.5,
			opacity: 1,
			translateX: 0
		})

		company.to(".company__container", {
			duration: 0.5,
			opacity: 1,
			translateY: 0
		}, "-=0.5")


		ScrollTrigger.batch(".calculator__item", {
			onEnter: batch => gsap.to(batch, {
				opacity: 1,
				scale: 1,
				y: 0,
				stagger: 0.1,
			}),
		});

		ScrollTrigger.batch(".article", {
			onEnter: batch => gsap.to(batch, {
				opacity: 1,
				scale: 1,
				y: 0,
				stagger: 0.1,
			}),
			onLeave: batch => gsap.to(batch, {
				opacity: 0,
				scale: 1.5,
				stagger: 0.1
			}),
			onEnterBack: batch => gsap.to(batch, {
				opacity: 1,
				scale: 1,
				stagger: 0.1
			}),
			onLeaveBack: batch => gsap.to(batch, {
				opacity: 0,
				scale: 1.5,
				stagger: 0.1
			}),
		});*/

	}
})


svg4everybody();

window.$ = $;
window.jQuery = $;
window.gsap = gsap;


